// Порядок = то, что реально видит пользователь: methodsInCustomOrder оставляет
// в списке только методы из этого массива.
export const METHODS_ORDER = [
  'cardlink_sbp',
  'cardlink',
  'cardlink_sberpay',
  'platega_sbp',
  'platega_card',
  'cardlink_copy_2',
  'cardlink_copy',
  'overpay',
  'overpay_sbp',
  'lava_card',
  'lava_sbp'
]
